import React from "react";
import { ModalDialog } from "react-bootstrap";
import Draggable from "react-draggable";

// interface DraggableModalDialogProps {
//   // Define your props if needed
// }

const DraggableModalDialog: React.FC = (props) => {
  return (
    <Draggable handle=".modal-header">
      <ModalDialog {...props} />
    </Draggable>
  );
};

export default DraggableModalDialog;
